import React from 'react'

const FormGroup = ({ children }) => <div className='form-group'>{children}</div>

export default FormGroup
